export default {"src":"/_next/static/media/REJECTED_CROSS.edb3c071.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};